import { fetchPostAPI, removeAndAddListeners } from "../general/BuddyFuncs";
import List from "list.js";

export default class TagFilter {
  constructor(
    params = {
      searchUrl: "",
      inputSelector: "",
      resultsSelector: "",
      tagsHolderSelector: "",
      clearSelector: "",
      itemHolderSelector: "",
      listSettings: {},
      minCharacters: 0,
      justReturnFilters: false,
    }
  ) {
    this.searchUrl = params.searchUrl;

    this.inputSelector = params.inputSelector;
    this.input = null;

    this.resultsSelector = params.resultsSelector;
    this.results = null;

    this.tagsHolderSelector = params.tagsHolderSelector;
    this.tagsHolder = null;

    this.clearSelector = params.clearSelector;
    this.clear = params.clearSelector;

    this.minCharacters = params.minCharacters ? params.minCharacters : 0;

    this.itemHolderSelector = params.itemHolderSelector;

    this.filters = [];

    this.list = null;
    this.listSettings = params.listSettings;

    this.justReturnFilters = params.justReturnFilters;

    //send event on change filter
    this.filterChange = new CustomEvent("changeFilter");
  }

  init() {
    //find elements
    this.input = document.querySelector(this.inputSelector);
    this.results = document.querySelector(this.resultsSelector);
    this.tagsHolder = document.querySelector(this.tagsHolderSelector);
    this.clear = document.querySelector(this.clearSelector);

    //handle input field
    removeAndAddListeners(this.input, "input", (e) =>
      this.handleInputFilter(e)
    );

    //handle clear tags
    removeAndAddListeners(this.clear, "click", (e) => this.handleClickClear(e));

    //setup list
    this.list = new List(this.itemHolderSelector, this.listSettings);
  }

  handleInputFilter(e) {
    const inputVal = e.currentTarget.value;

    //check if enough characters
    if (inputVal.length >= this.minCharacters) {
      //get new search results and display them
      this.getSearchResults(inputVal);
    } else {
      //hide results again
      this.toggleResults(false);
    }
  }

  getSearchResults(inputVal) {
    const sendData = new FormData();

    sendData.append("searchVal", inputVal);
    sendData.append("filters", this.fitlers);

    let results = [];
    document
      .querySelectorAll("." + this.itemHolderSelector + " .card")
      .forEach((card) => {
        const tle = card.querySelector(".title").innerHTML;
        if (new RegExp('(?:^|\\s)'+inputVal, 'i').test(tle) || new RegExp('(?:^|\\s)'+inputVal, 'i').test(card.dataset.date) || new RegExp('(?:^|\\s)'+inputVal, 'i').test(card.dataset.category) || new RegExp('(?:^|\\s)'+inputVal, 'i').test(card.dataset.author)) {
          results.push({
            title: tle,
            date: card.dataset.date,
            category: card.dataset.category,
          });
        }
      });

      this.updateResults(inputVal, results);
    /* this.updateResults(inputVal, [
      {
        title: "Titel",
        type: "Agribex",
        category: "akkerbouw",
      },
      {
        title: "title",
        type: "",
        category: "veeteelt",
      },
      {
        title: "title",
        type: " ",
        category: "tuin",
      },
    ]); */

    //fetchPostAPI(this.searchUrl, sendData).then((r) => this.updateResults(inputVal, r));
  }

  clearResults() {
    this.results.innerHTML = "";
  }

  highlightSearchQuery(searchQuery, searchResult) {
    return searchResult.replace(
      new RegExp(searchQuery, "ig"),
      `<span class="bold">${searchQuery}</span>`
    );
  }

  updateResults(searchQuery, data) {
    //open the results
    this.toggleResults(true);

    //clear current items
    this.clearResults();

    //add new results
    data.forEach((result) => {
      this.results.innerHTML += `
      <li class="card ${result.category}" data-category="${
        result.category
      }" data-title="${result.title}" data-date="${result.date}">
        <div class="resultHolder">
            <p class="searchResult">${this.highlightSearchQuery(
              searchQuery,
              result.title
            )}</p>
            <p class="type">${result.date}</p>
        </div>
      </li>`;
    });

    if (this.results.innerHTML === "") { this.results.innerHTML = "no results"; };

    //addlisteners to the new elements
    this.results
      .querySelectorAll("li")
      .forEach((result) =>
        removeAndAddListeners(result, "click", (e) => this.handleClickResult(e))
      );
  }

  handleClickResult(e) {
    e.preventDefault();
    const elem = e.currentTarget.dataset;

    //add tag to list
    this.addTag(elem.title, elem.category, elem.date);
  }

  addTag(title, category, date) {
    //add elem to filters
    this.filters.push({
      title,
      category,
      date,
    });

    //add new tag element
    this.tagsHolder.innerHTML += `
    <button class="tag pill ${category}Texture" data-title="${title}">
      <span>${title}</span>
      <span class="pillBtn closeIconWhite"><span class="hide">delete tag</span></span>
    </button>`;

    //add listeners to delete the tags
    this.tagsHolder.querySelectorAll("button").forEach((tag) => {
      removeAndAddListeners(tag, "click", (e) => this.deleteTag(e));
    });

    //clear the input
    this.clearInput();

    //filter items
    this.filterItems();
  }

  deleteTag(e) {
    e.preventDefault();
    const title = e.currentTarget.dataset.title;

    //remove from filter
    this.filters = this.filters.filter((filter) => filter.title !== title);

    //remove element
    e.currentTarget.outerHTML = "";

    //filter items
    this.filterItems();
  }

  filterItems() {
    if (!this.justReturnFilters) {
      this.list.filter((item) => {
        let matchesFilters = this.filters.length > 0 ? false : true;

        this.filters.forEach((filter) => {
          if (item.values().title === filter.title) {
            matchesFilters = true;
          }
        });

        return matchesFilters;
      });
    } else {
      //send event
      window.dispatchEvent(this.filterChange);
    }
  }

  clearInput() {
    //clear input
    this.input.value = "";

    //clear results
    this.clearResults();

    //hide results bar
    this.toggleResults(false);
  }

  clearTags() {
    //clear the filters
    this.filters = [];

    //clear the tags
    this.tagsHolder.innerHTML = "";
  }

  toggleResults(isOpen = false) {
    if (this.results) {
      if (isOpen) {
        this.results.classList.add("open");
      } else {
        this.results.classList.remove("open");
      }
    }
  }

  handleClickClear(e) {
    e.preventDefault();

    //clear input
    this.clearInput();

    //clear results
    this.clearResults();

    //clear tags
    this.clearTags();
  }
}
